import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { recipes } from '../services/api';
import { useAuth } from '../context/AuthContext';
import '../styles/Admin.css';

const Admin = () => {
  const [pendingRecipes, setPendingRecipes] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Wait for AuthContext to restore the session before deciding.
    if (authLoading) return;

    if (!user || user.role !== 'admin') {
      navigate('/');
      return;
    }

    fetchPendingRecipes();
  }, [user, authLoading]);

  const fetchPendingRecipes = async () => {
    try {
      const response = await recipes.getAll({ approved: false });
      setPendingRecipes(response.data);
    } catch (error) {
      console.error('Error fetching pending recipes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      await recipes.approve(id);
      setPendingRecipes(pendingRecipes.filter(recipe => recipe._id !== id));
      alert('Recept jóváhagyva!');
    } catch (error) {
      console.error('Error approving recipe:', error);
      alert('Hiba történt a jóváhagyás során');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Biztosan törölni szeretnéd ezt a receptet?')) {
      try {
        await recipes.delete(id);
        setPendingRecipes(pendingRecipes.filter(recipe => recipe._id !== id));
      } catch (error) {
        console.error('Error deleting recipe:', error);
        alert('Hiba történt a törlés során');
      }
    }
  };

  if (loading) {
    return <div className="container loading">Betöltés...</div>;
  }

  return (
    <div className="admin-page">
      <div className="container">
        <h1>Admin Felület</h1>

        <div className="admin-stats">
          <div className="stat-card card">
            <h3>Jóváhagyásra váró</h3>
            <p className="stat-number">{pendingRecipes.length}</p>
          </div>
        </div>

        <div className="pending-recipes-section">
          <h2>Jóváhagyásra váró receptek</h2>

          {pendingRecipes.length === 0 ? (
            <div className="no-pending">
              <p>Nincs jóváhagyásra váró recept.</p>
            </div>
          ) : (
            <div className="recipes-table">
              <table>
                <thead>
                  <tr>
                    <th>Cím</th>
                    <th>Szerző</th>
                    <th>Kategória</th>
                    <th>Nehézség</th>
                    <th>Létrehozva</th>
                    <th>Műveletek</th>
                  </tr>
                </thead>
                <tbody>
                  {pendingRecipes.map((recipe) => (
                    <tr key={recipe._id}>
                      <td>
                        <Link to={`/recipe/${recipe._id}`} className="recipe-title-link">
                          {recipe.title}
                        </Link>
                      </td>
                      <td>{recipe.author?.name}</td>
                      <td>{recipe.category}</td>
                      <td>{recipe.difficulty}</td>
                      <td>{new Date(recipe.createdAt).toLocaleDateString('hu-HU')}</td>
                      <td className="actions">
                        <Link to={`/recipe/${recipe._id}`} className="btn btn-sm btn-secondary">
                          Megtekintés
                        </Link>
                        <button
                          onClick={() => handleApprove(recipe._id)}
                          className="btn btn-sm btn-success"
                        >
                          Jóváhagyás
                        </button>
                        <button
                          onClick={() => handleDelete(recipe._id)}
                          className="btn btn-sm btn-outline"
                        >
                          Törlés
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Admin;
